import { useSelector } from 'react-redux';
import { getProductsListAfterValidation } from 'src/common/organisms/setItemDetails/helperFunction/helperFunctions';

export function useSetDetailsSelectors({ isEquity, isConsignmentAdd, isSetDetail, selectedSegment}) {
    const {
        countryISOCode,
        isLanguageChanged,
        isCondensedView,
        data,
        loading,
        initialList,
    } = useSelector((state) => ({
        countryISOCode: state.loginReducer.hybrisUserDetails.countryISOCode,
        isLanguageChanged: state.loginReducer.isLanguageChanged,
        isCondensedView: state.loginReducer.isCondensedView,
        data: isEquity
            ? state.equityProductDetailsReducer.data
                ? getProductsListAfterValidation(
                      state.equityProductDetailsReducer.data,
                      state.equityValidateProductsReducer.validatedProducts,
                      isSetDetail, selectedSegment
                  )
                : null
            : isConsignmentAdd
            ? state.consignmentAddProductDetailsReducer.data
                ? getProductsListAfterValidation(
                      state.consignmentAddProductDetailsReducer.data,
                      state.consignmentAddValidateProductsReducer.validatedProducts,
                      isSetDetail, selectedSegment
                  )
                : null
            : state.productDetailsReducer.data
            ? getProductsListAfterValidation(
                  state.productDetailsReducer.data,
                  state.validateProductsReducer.validatedProducts,
                  isSetDetail, selectedSegment
              )
            : null,
        initialList: isEquity
            ? state.equityProductDetailsReducer.initialList
                ? getProductsListAfterValidation(
                      state.equityProductDetailsReducer.initialList,
                      state.equityValidateProductsReducer.validatedProducts,
                      isSetDetail, selectedSegment
                  )
                : null
            : isConsignmentAdd
            ? state.consignmentAddProductDetailsReducer.initialList
                ? getProductsListAfterValidation(
                      state.consignmentAddProductDetailsReducer.initialList,
                      state.consignmentAddValidateProductsReducer.validatedProducts,
                      isSetDetail, selectedSegment
                  )
                : null
            : state.productDetailsReducer.initialList
            ? getProductsListAfterValidation(
                  state.productDetailsReducer.initialList,
                  state.validateProductsReducer.validatedProducts,
                  isSetDetail, selectedSegment
              )
            : null,
        loading: isEquity
            ? state.equityProductDetailsReducer.loading
            : isConsignmentAdd
            ? state.consignmentAddProductDetailsReducer.loading
            : state.productDetailsReducer.loading,
    }));

    return {
        countryISOCode,
        isLanguageChanged,
        isCondensedView,
        data,
        loading,
        initialList,
    };
}